

<template>
    <div>
        <!-- <h1>form3</h1> -->
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol"  :rules="rules">
            <!-- <div class="item-line">经销商信息</div> -->
            <a-row class="flex-row">
                <a-col :span="6">
                    <a-form-model-item label="客户数量" prop="customerCount">
                        <a-input-number :min="0" v-model="form.customerCount" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="车辆数" prop="vehicleCount">
                        <a-input-number :min="0" v-model="form.vehicleCount" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="客户品系"  prop="strainsNameList">
                      <div style="display: flex; flex-direction: column; gap: 4px;width: 100%">
                        <a-select v-model="form.strainsNameList" mode="multiple" placeholder="请选择品系" :collapse-tags="true" @change="onStrainsChange" :disabled="isDisabled()">
                          <!-- <a-select-option  value="0" >全部</a-select-option> -->
                          <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode"  :value="item.strains" >{{item.strains}}</a-select-option>
                        </a-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.4;">
                          注意：公路用车与工程用车不可同时选择
                        </div>
                      </div>
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-model-item label="主推车型及数量" prop="strainsCarName" :label-col="{span:9}">
                        <a-select
                            ref="selectCarSeriesPopup"
                            v-model="form.strainsCarName"
                            placeholder="主推车型及数量"
                            class="proxySelect"
                            :visible-change="false"
                            @click.native="onShowCarSeries"
                        />
                    </a-form-model-item>
                </a-col> -->
                <!-- <a-col :span="6">
                    <a-form-model-item label="计划时间" prop="planTime">
                        <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.planTime" class="date-picker"/>
                    </a-form-model-item>
                </a-col> -->
                <a-col :span="12">
                    <a-form-model-item label="地点" prop="activityPlace" >
                        <a-cascader
                            v-model="form.activityPlace"
                            :options="regionOptions"
                            :fieldNames="{ label: 'areaName', value: 'areaName', children: 'children' }"
                            placeholder="请选择地点"
                            allowClear
                            :disabled="isDisabled()"
                        />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="详细地址" >
                        <a-input v-model="form.addressInfo" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
            <!-- <div class="item-line">负责人信息</div> -->
             <!-- lr0046 -->
                <a-col :span="6">
                    <a-form-model-item label="负责人姓名" prop="headName">
                        <a-input v-model="form.headName" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="负责人电话" prop="headPhone">
                        <a-input v-model="form.headPhone" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                  <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{span:4}" class="sign-tiem widthHuo">
                          <a-textarea :auto-size="{ minRows: 2, maxRows: 6 }" v-model="form.remark" :disabled="isDisabled()" />
                      </a-form-model-item>
                  </a-col>
            <div class="item-line">费用预算</div>
                <a-col :span="6">
                    <a-form-model-item label="会务费">
                        <a-input-number :min="0" v-model="form.conferenceFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="油费">
                        <a-input-number :min="0" v-model="form.fuelCost" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="过路费">
                        <a-input-number :min="0" v-model="form.toll" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="礼品费">
                        <a-input-number :min="0" v-model="form.giftFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="布展费">
                        <a-input-number :min="0" v-model="form.moveInFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="其他">
                        <a-input-number :min="0" v-model="form.otherFee" @change="gettotalCost" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="合计">
                        <!-- <a-input-number :min="0" v-model="form.totalCost" /> -->
                        <a-input-number :min="0" v-model="form.totalCost" disabled />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <!-- 审批人可见 -->
            <a-row v-if="approveBtnDisplay === true">
            <!-- <a-row> -->
                <a-col :span="6">
                    <a-form-model-item label="经销商已补差">
                        <a-input v-model="form.dealerDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="区域已补差">
                        <a-input v-model="form.areaDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="最高支持费用">
                        <a-input v-model="form.maxSupportFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
            </a-row>
           
        </a-form-model>
        <a-modal title="选择车型" :visible.sync="showCarSeries" width="40%" @cancel="showCarSeries=false" class="car-modal">
            <vxe-table
              ref="xTable"
              border
              class="mytable-scrollbar"
              show-header-overflow
              show-overflow
              :column-config="{ resizable: true }"
              stripe
              round
              style="margin-top: 10px"
              :max-height="$store.state.app.height - 350 < 185 ? 185 : $store.state.app.height - 350"
              :scroll-y="{ enabled: false }"
              :row-config="{ isHover: true }"
              :checkbox-config="{checkRowKeys: defaultSelecteRows}"
              :data="carList"
            >
              <vxe-column type="checkbox" width="60" align="center" />
              <vxe-column type="seq" title="序号" width="60" align="center" />
              <vxe-column field="vCode" title="车型" align="center">
              </vxe-column>
              <vxe-column field="quantity" title="车型数量" align="center">
                <template #default="{ row }">
                    <a-input-number :min="0" v-model="row.quantity"/>
                  </template>
              </vxe-column>
            </vxe-table>
            <span slot="footer" class="dialog-footer">
              <vxe-button @click="showCarSeries = false">取 消</vxe-button>
              <vxe-button status="primary" @click="onSeriesConfirm">确 定</vxe-button>
            </span>
          </a-modal>
      
    </div>
</template>

<script>
import { loadAreaTreeCasData } from '@/services/baseCodeSource';
import { queryCarStrainsInfo, getApproveWriteOffCost } from '@/api/activity.js'   // getCarTypeList

export default {
  props:['formData', 'activity', 'formType', 'approveBtnType'],
  data() {
    return {
      labelCol: { span: 8, style: { width: '100px' } },
      wrapperCol: { span: 14 },
      form: {
        address: [], // 区域
        dealerName: '', // 经销商
        threeLevelName: '', // 活动类型
        customerCount: null, // 客户数量
        vehicleCount: null, //车辆数
        strainsNameList: [], // 客户品系
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        // planTime: '',  // 计划时间
        activityPlace: [], // 地点
        showRoute: '',  // 展示路线   表单2类型
        addressInfo:'', // 详细地址
        // isSecondaryNetwork: 1, // 是否二网活动 1 是 2 否
        // secondaryNetworkName: '', // 二网活动名称
        headName: '', // 负责人名称
        headPhone: '', // 负责人电话
        conferenceFee: '', //会务费
        fuelCost: '', // 油费
        toll: '', // 过路费
        giftFee: '', // 礼品费
        moveInFee: '', // 布展费
        otherFee: '', // 其他费用
        totalCost: 0, //总计
        dealerDiff: '',
        areaDiff: '',
        maxSupportFee: '',
        remark: ''
        // annualFee: 0, //年费
        // trainingFee: 0, //培训费
        // siteRent: 0, //场地租金
        // makeCosts: 0, //制作费用
        // otherSiteExpenses: 0, //其他场地费用
      },
      rules: {
        address: [
          { required: true, message: '请选择区域', trigger: 'change' },
        ],
        dealerName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        threeLevelName: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        strainsNameList: [
          { required: true, message: '请选择主推品系', trigger: 'change' },
        ],
        strainsCarName: [
          { required: true, message: '请选择主推车型及数量', trigger: 'change' },
        ],
        planTime: [
          { required: true, message: '请选择计划时间', trigger: 'change' },
        ],
        activityPlace: [
          { required: true, message: '请输入地点', trigger: 'change' },
        ],
        isSecondaryNetwork: [
          { required: true, message: '', trigger: 'change' },
        ],
        headName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        headPhone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' },
        ],
      },
      regionOptions:[],
      showCarSeries: false,
      defaultSelecteRows: [], // 默认选中行
      vehicleModelAndQuantity: [], //已选车型
      vehicleModelCheck: 0, // 0不检验 1校验 车型代码必选
      // 车型列表
      carList: [], 
      carStrainsDS: [],
      approveBtnDisplay: false
    };
  },
  created() {
    this.getArea()
    this.SelectListsFun()
    this.getCarStrains()
  },
    mounted() {
        if (this.formData && this.formData.id) {
            setTimeout(() => {
              this.getApproveWriteOffCost()
              this.form = Object.assign(this.form, {
                  ...this.formData,
                  vehicleModelAndQuantity: this.formData.vehicleModelAndQuantity || [],
                  activityPlace: Array.isArray(this.formData.activityPlace) 
                    ? this.formData.activityPlace 
                    : (this.formData.activityPlace ? this.formData.activityPlace.split(',') : [])
              })
              this.vehicleModelAndQuantity = Array.isArray(this.formData.vehicleModelAndQuantity) 
                ? this.formData.vehicleModelAndQuantity 
                : []
              const list = this.vehicleModelAndQuantity.map(item => `车型名称：${item.vehicleModel} - 数量：${item.quantity}`)
              this.form.strainsCarName = list.join('; ')
              if(this.carStrainsDS != null){
                this.form.strainsCodeNameMap = this.carStrainsDS
                    .filter(item => this.formData.strainsCodeList.includes(item.strainsCode))
                    .reduce((obj, item) => {
                      obj[item.strainsCode] = item.strains;
                      return obj;
                    }, {});
              }
              // this.form.dealerDiff = this.priceDiff.dealerDiff
              // this.form.areaDiff = this.priceDiff.areaDiff
            }, 3000)
        }
    },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    async getArea() {
      this.regionOptions = await loadAreaTreeCasData();
    },
    onShowCarSeries() {
        if (!this.form.strainsNameList) {
            this.$message.error('请先选择主推品系')
            return
        }
      this.$refs.selectCarSeriesPopup.blur()
      this.showCarSeries = true
      this.$nextTick(() => {
        if (!this.form.strainsCarName) {
            this.$refs.xTable.clearCheckboxRow()
        }
        // this.$refs.xTable.clearCheckboxRow()
        // const stringArray = this.activity.strainsCarCode.split(',')
        // const result = this.SelectLists.subSeries.filter(item => stringArray.some(value => item.code === value))
        // this.$refs.xTable.setCheckboxRow(result, true)
      })
    },
    onSeriesConfirm() {
        this.vehicleModelAndQuantity = this.$refs.xTable.getCheckboxRecords();
        console.log("🚀 ~ onSeriesConfirm ~ this.vehicleModelAndQuantity:", this.vehicleModelAndQuantity)
        if (!this.vehicleModelAndQuantity.length) {
           return  this.$message.error('请选择车型')
        }
        if (this.vehicleModelAndQuantity.some(item => item.count === '')) {
            return  this.$message.error('请输入已选车型的数量')
        }
        this.showCarSeries = false
        const list = this.vehicleModelAndQuantity.map(item => `车型名称：${item.vehicleModel} - 数量：${item.quantity}`)
        this.form.strainsCarName = list.join('; ')
    },
    gettotalCost() {
        this.form.totalCost = Number(this.form.conferenceFee) + Number(this.form.fuelCost) 
        + Number(this.form.toll) + Number(this.form.giftFee) + Number(this.form.moveInFee) + Number(this.form.otherFee)
    },
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
          this.filteredStrains()
        }
      })
    },
    getApproveWriteOffCost() {
        getApproveWriteOffCost(this.formData.id).then(res => {
            if (res.code === 1) {
                this.form.dealerDiff = res.data.dealerApproveWriteOffCost
                this.form.areaDiff = res.data.regionApproveWriteOffCost
                this.approveBtnDisplay = res.data.display
            }
        })
    },
    // 过滤品系
    filteredStrains() {
      if (this.activity.strainsCarCode) {
        const stringArray = this.activity.strainsCarCode.split(',')
        const arr = []
        stringArray.forEach(item => {
          const itemArr = item.split('-')
          arr.push(itemArr[0])
        })
        this.carStrainsDS = this.carStrainsDS.filter(value => arr.includes(value.strainsCode))
      }
    },
    async onStrainsChange (e) {
      console.log(e);
      this.form.strainsCodeNameMap = this.carStrainsDS
          .filter(item => e.includes(item.strains))
          .reduce((obj, item) => {
            obj[item.strainsCode] = item.strains;
            return obj;
          }, {});

        // const id = this.carStrainsDS.find(item => item.strains === e).strainsCode
        // const res = await getCarTypeList(id)
        // this.carList = res.data.map(item => {
        //    return {
        //     vehicleModel: item.vCodeId,
        //     quantity: null,
        //     ...item
        //    }
        // })

    },
    getActivityForm() {
      const processedForm = {
        ...this.form,
        conferenceFee: this.form.conferenceFee ?? 0,
        fuelCost: this.form.fuelCost ?? 0,
        toll: this.form.toll ?? 0,
        giftFee: this.form.giftFee ?? 0,
        moveInFee: this.form.moveInFee ?? 0,
        otherFee: this.form.otherFee ?? 0,
        totalCost: this.form.totalCost ?? 0
      };

      const obj = Object.assign(processedForm, {
            address: this.activity.address,
            dealerName: this.activity.dealerName,
            threeLevelName: this.activity.threeLevelName,
            vehicleModelAndQuantity: this.vehicleModelAndQuantity,
            activityPlace: Array.isArray(this.form.activityPlace) 
                ? this.form.activityPlace.join(',') 
                : this.form.activityPlace
        })
        return obj
    },
    isDisabled() {
        console.log("🚀 ~ isDisabled ~ this.formType:", this.formType)
        return this.formType === 'detail'
    }
  }
}
</script>

<style lang="less" scoped>
.item-line {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .ant-form {
    padding-right: 0;
  }
  /deep/ .ant-form-explain {
    font-size: 12px;
  }
  .widthHuo{
    ::v-deep .ant-form-item-label{
      width:100px !important
    }
  }
</style>
